import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { CompanyService } from '../CompanyService';
import { ErrorToast } from '../../../utils/toasters';

interface ICreateGroupOptionModal {
    show: boolean;
    groupId: number;
    onHide: () => void;
    onCreated: (groupId: number, option: any) => void;
}

const initialForm = { label: '', labelDe: '' };

export function CreateGroupOptionModal({ show, groupId, onHide, onCreated }: ICreateGroupOptionModal) {
    const [form, setForm] = useState(initialForm);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSubmit = () => {
        const body = {
            label: form.label,
            ...(form.labelDe && { labelDe: form.labelDe }),
        };
        CompanyService.createGroupOption(groupId, body)
            .then(data => {
                onCreated(groupId, data);
                setForm(initialForm);
                onHide();
            })
            .catch(err => ErrorToast(err));
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Add option</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group className="mb-3">
                    <Form.Label>
                        Label EN <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control name="label" value={form.label} onChange={handleChange} />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Label DE</Form.Label>
                    <Form.Control name="labelDe" value={form.labelDe} onChange={handleChange} />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-primary" onClick={onHide}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleSubmit} disabled={!form.label}>
                    Create
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
